import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import {
  FilterType,
  PowerLimitationControlCommandType,
  PowerLimitationFilterDateAndType,
  PowerLimitationHistoryState,
  PowerLimitationTableList,
} from '@store';

import { AppState } from '../app.state';

export namespace PowerLimitationHistorySelectors {
  export const powerLimitationState = (state: AppState): PowerLimitationHistoryState =>
    state.powerLimitationHistory;

  export function selectControlCommandType(): MemoizedSelector<
    AppState,
    PowerLimitationControlCommandType,
    DefaultProjectorFn<PowerLimitationControlCommandType>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): PowerLimitationControlCommandType =>
        state.powerLimitationControlCommandType
    );
  }

  export function selectFilterDateType(): MemoizedSelector<
    AppState,
    FilterType,
    DefaultProjectorFn<FilterType>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): FilterType => {
        return state.filterDateAndType.type;
      }
    );
  }

  export function selectFilterDateAndType(): MemoizedSelector<
    AppState,
    PowerLimitationFilterDateAndType,
    DefaultProjectorFn<PowerLimitationFilterDateAndType>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): PowerLimitationFilterDateAndType => {
        return state.filterDateAndType;
      }
    );
  }

  export function selectFilteredData(): MemoizedSelector<
    AppState,
    PowerLimitationTableList[],
    DefaultProjectorFn<PowerLimitationTableList[]>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): PowerLimitationTableList[] => state.selectedFilterData
    );
  }

  export function selectPowerLimitationAmount(): MemoizedSelector<
    AppState,
    number,
    DefaultProjectorFn<number>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): number => state.powerLimitationData.length
    );
  }

  export function selectConsumptionLimitationAmount(): MemoizedSelector<
    AppState,
    number,
    DefaultProjectorFn<number>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): number =>
        state.powerLimitationData.filter(
          (powerLimitation) =>
            powerLimitation.controlCommand ===
            PowerLimitationControlCommandType.ConsumptionLimitation
        ).length
    );
  }

  export function selectProductionLimitationAmount(): MemoizedSelector<
    AppState,
    number,
    DefaultProjectorFn<number>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): number =>
        state.powerLimitationData.filter(
          (powerLimitation) =>
            powerLimitation.controlCommand ===
            PowerLimitationControlCommandType.ProductionLimitation
        ).length
    );
  }

  export function selectLoading(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      powerLimitationState,
      (state: PowerLimitationHistoryState): boolean => state.loading
    );
  }
}
